import React from 'react';
import './FeatureSection.css';

function FeatureSection() {
  return (
    <div className="hero">
      <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/6b9a74a84dfcab7d50029b642bf24a5b769d303e945b68363f41230c9978a637?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214" alt="Background" className="hero-bg" />
      <div className="hero-content">
        <h1>Begin Your Screening Journey with Confidence</h1>
        <p>
        Dive into a tailored assessment designed to evaluate your strengths,
        identify growth areas, and set you on the path to success.
        </p>
      </div>
    </div>
  );
}

export default FeatureSection;